/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S3_HeadingInputs */

const tr_kullanim_s3_heading = /** @type {(inputs: Kullanim_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Sözleşmenin Konusu`)
};

const en_kullanim_s3_heading = /** @type {(inputs: Kullanim_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Subject matter of the Agreement`)
};

const de_kullanim_s3_heading = /** @type {(inputs: Kullanim_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Gegenstand des Vertrags`)
};

const ru_kullanim_s3_heading = /** @type {(inputs: Kullanim_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Предмет Договора`)
};

/**
* | output |
* | --- |
* | "3. Subject matter of the Agreement" |
*
* @param {Kullanim_S3_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s3_heading = /** @type {((inputs?: Kullanim_S3_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S3_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s3_heading(inputs)
	if (locale === "de") return de_kullanim_s3_heading(inputs)
	if (locale === "ru") return ru_kullanim_s3_heading(inputs)
	return tr_kullanim_s3_heading(inputs)
});